import { useQuery } from '@apollo/client';

import { SearchMode } from '@xing-com/crate-common-graphql-types';
import { SEARCH_BOX_MAX_RECENT_SEARCHES } from '@xing-com/crate-jobs-constants';
import { GetRecentSearchesDocument } from '@xing-com/crate-jobs-graphql';

type UseRecentSearchesArgs = {
  skip?: boolean;
};

export const useRecentSearches = ({
  skip,
  // oxlint-disable-next-line typescript/explicit-function-return-type
}: UseRecentSearchesArgs) => {
  const { data, loading, refetch } = useQuery(GetRecentSearchesDocument, {
    variables: {
      consumer: 'loggedin.web.jobs.search',
      limit: SEARCH_BOX_MAX_RECENT_SEARCHES,
      searchMode: SearchMode.Semantic,
    },
    skip,
  });

  return {
    isLoading: loading,
    recentSearches: data?.viewer?.jobRecentSearchesJS?.searches,
    refetch,
  };
};
